export const MOBILE_MENU = 'MOBILE_MENU' 
export const ACTIVEMENU = 'ACTIVEMENU' 
 